<template>
  <div class="pdf-container">
    <div class="pdf-content">
      <div class="pdf-pages">
        <div class="pdf-page" v-for="page in pageCount" :key="page">
          <pdf :src="pdfSrc" :page="page"></pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: 'PdfComponent',
  components: {
    pdf,
  },
  props: {
    // PDF文件路径或URL
    pdfUrl: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      pdfSrc: '',
      pageCount: 0,
      pdfLoadingTask: null,
      defaultBaseUrl: window.globalUrl?.HOME_API + 'admin/file/get?ossFilePath='
    }
  },
  watch: {
    // 监听PDF URL变化，重新加载PDF
    pdfUrl: {
      handler(newUrl) {
        if (newUrl) {
          this.loadPdf(newUrl);
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadPdf(url) {
      try {
        let finalUrl = this.defaultBaseUrl + url;
        this.pdfLoadingTask = pdf.createLoadingTask(finalUrl);
        this.pdfSrc = this.pdfLoadingTask;
        
        const pdfDoc = await this.pdfLoadingTask.promise;
        this.pageCount = pdfDoc.numPages;
      } catch (error) {
        console.error('加载PDF文件失败:', error);
        this.pdfSrc = '';
        this.pageCount = 0;
        this.pdfLoadingTask = null;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pdf-container {
  /* 使用固定高度来确保在指定大小的div中显示 */
  height: 100%;
  /* 如果容器高度可能被覆盖，提供默认高度值 */
  min-height: 500px;
  max-height: 80vh;
  padding: 16px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
}

.pdf-content {
  /* 确保内容区域占满容器 */
  height: 100%;
  /* 启用垂直滚动 */
  overflow-y: auto;
  /* 隐藏水平滚动条 */
  overflow-x: hidden;
}

.pdf-pages {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 确保内容不会溢出 */
  width: 100%;
}

.pdf-page {
  /* 使用固定宽度的百分比，确保在容器中正确显示 */
  width: 90%;
  /* 设置最大宽度以避免在宽屏上过度拉伸 */
  max-width: 860px;
  /* 页面间距 */
  margin: 10px 0;
  padding: 10px;
  background: #f8f8f8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .pdf-container {
    min-height: 400px;
    max-height: 70vh;
    padding: 10px;
  }
  
  .pdf-page {
    width: 95%;
    margin: 5px 0;
    padding: 5px;
  }
}

/* PDF内容样式 */
:deep(.vue-pdf) {
  display: flex;
  justify-content: center;
  width: 100%;

  canvas {
    /* 确保canvas不会超出容器宽度 */
    max-width: 100%;
    /* 保持比例 */
    height: auto;
  }
}

/* 自定义滚动条样式，提升用户体验 */
.pdf-content::-webkit-scrollbar {
  width: 8px;
}

.pdf-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.pdf-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.pdf-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>